import { NoticeTypes, UI } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';

import { DirectTreasuryDetailsModalComponentsProps } from '../..';

export const DirectTreasuryDetailsMarket = ({
  directTreasuryMarketStatus,
}: DirectTreasuryDetailsModalComponentsProps) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  if (!directTreasuryMarketStatus) {
    return <></>;
  }

  const isOpen = directTreasuryMarketStatus.marketStatus.isOpened;

  const messageText: NoticeTypes.TextObject = {
    text:
      directTreasuryMarketStatus.marketStatus.internalMessage ||
      directTreasuryMarketStatus.marketStatus.message ||
      '',
    variant: 'regular',
  };

  return (
    <UI.Notice
      testId="notice-not-today"
      type={isOpen ? 'alert' : 'warning'}
      fontSize={Typography[isDesktop ? 'fontsize.md' : 'fontsize.xs']}
      backgroundColor={Utils.ColorToken.WithOpacity(
        isOpen ? 'feedback.gen.lightest' : 'feedback.attention.lightest',
        'opacity.medium'
      )}
      textObjects={
        isOpen ? [messageText] : [{ text: 'Mercado fechado: ', variant: 'semibold' }, messageText]
      }
    />
  );
};
